<copo-ecalloff-header	objectTranslationKey="ecall-off.order-items"
						[copyTo]="this.stepState?.copyTo ?? ''"
						[customerCalloffReference]="this.stepState?.customerCalloffReference ?? ''"
						[editCustomerCalloffReference]="true"
						[editCopyTo]="true"
						[editRddMode]="true"
						[nbOrderItems]="this.stepState?.selectedOrderItems?.length ?? 0"
						[rddMode]="this.stepState?.rddMode"
						[totalWeight]="getTotalWeight()"
						(formChange)="onInfoEntryHeaderChange($event)"></copo-ecalloff-header>

<copo-infoentry-calloff-header *ngIf="(this.stepState?.selectedOrderItems ?? []).length > 0"
	[rddMode]="this.stepState?.rddMode"
	[shipToDetails]="shipToDetails"
	[unloadingRef]="unloadingRef"
	[selectedShipTo]="selectedShipTo"
	[allowChangeOfShipto]="allowChangeOfShipto"
	(applyAll)="onInfoEntryCalloffHeaderApplyAll($event)"></copo-infoentry-calloff-header>

<div class="margin">
	<ng-container *ngFor="let orderItem of (this.stepState?.selectedOrderItems ?? [])">
		<copo-callable-order-item 	class="order-item"
									[orderItem]="orderItem"
									[editCalledVolume]="true"
									[editDateFrom]="editDateFrom"
									[editDateTo]="editDateTo"
									[editUnloadingReference]="true"
									[showMenu]="true"
									[shipToDetails]="shipToDetails"
									(callableOrderItemChange)="onCallableOrderItemChange($event)"
									(callableOrderItemDelete)="onCallableOrderItemDelete($event)"
									(callableOrderItemView)="onCallableOrderItemView($event)">
		</copo-callable-order-item>
	</ng-container>
</div>